<template>
  <svg
    width="22px"
    height="12px"
    viewBox="0 0 22 12"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Symbols"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="user-accoount-row"
        transform="translate(-1480, -13)"
        fill="#359685"
        fill-rule="nonzero"
      >
        <g
          id="password_FILL1_wght400_GRAD0_opsz24"
          transform="translate(1480, 13)"
        >
          <path
            id="Shape"
            d="M1,12 L1,10 L21,10 L21,12 L1,12 Z M2.15,5.95 L0.85,5.2 L1.7,3.7 L0,3.7 L0,2.2 L1.7,2.2 L0.85,0.75 L2.15,0 L3,1.45 L3.85,0 L5.15,0.75 L4.3,2.2 L6,2.2 L6,3.7 L4.3,3.7 L5.15,5.2 L3.85,5.95 L3,4.45 L2.15,5.95 Z M10.15,5.95 L8.85,5.2 L9.7,3.7 L8,3.7 L8,2.2 L9.7,2.2 L8.85,0.75 L10.15,0 L11,1.45 L11.85,0 L13.15,0.75 L12.3,2.2 L14,2.2 L14,3.7 L12.3,3.7 L13.15,5.2 L11.85,5.95 L11,4.45 L10.15,5.95 Z M18.15,5.95 L16.85,5.2 L17.7,3.7 L16,3.7 L16,2.2 L17.7,2.2 L16.85,0.75 L18.15,0 L19,1.45 L19.85,0 L21.15,0.75 L20.3,2.2 L22,2.2 L22,3.7 L20.3,3.7 L21.15,5.2 L19.85,5.95 L19,4.45 L18.15,5.95 Z"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</template>
